import React from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import {greeting} from "../../portfolio";

export default function Footer() {
  return (
    <Fade bottom duration={1000} distance="5px">
      <div style={{display: "flex", justifyContent: "center"}}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
      </div>
    </Fade>
  );
}
